export default "__VITE_ASSET__CtVlC1sc__"